export default __webpack_public_path__ + "static/media/person-icon.14e81640.svg";